module.exports = __webpack_public_path__ + "img/Call.99742a69.svg";